import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@abb/uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const ReadMore = (param)=>{
    let { children } = param;
    const { t } = useTranslation('common');
    const [isReadMore, setIsReadMore] = React.useState(true);
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    return /*#__PURE__*/ _jsxs(Text, {
        display: "inline",
        width: "100%",
        textAlign: "center",
        children: [
            isReadMore ? children.slice(0, 150) : children,
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                onClick: toggleReadMore,
                color: "rgba(59, 141, 212, 1)",
                cursor: "pointer",
                children: isReadMore ? t('actions.read_more') : t('actions.read_less')
            })
        ]
    });
};
